import React from 'react';
import Chart from 'react-apexcharts';

const SparklineChart4 = ({data}) => {
  const uniqueUniqueInsightCount = new Set(data.map(item => item.insight)).size;
  const labels = [...Array(uniqueUniqueInsightCount).keys()].map(n => `Insight ${n + 1}`);
  const sparklineData = [10, 40, 70, 60, 80, 60, 80, 110, 130, 50, 5, 10, 2];
  const spark2 = {
    chart: {
      id: 'sparkline2',
      group: 'sparklines',
      type: 'area',
      height: 100,
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      curve: 'straight',
    },
    fill: {
      opacity: 1,
    },
    series: [
      {
        name: 'Total Insight',
        data: sparklineData,
      },
    ],
    labels,
    xaxis: {
      type: "category",
    },
    yaxis: {
      min: 0,
    },
    colors: ["#fff"],
    title: {
      text: 'Total Insight',
      offsetX: 30,
      style: {
        fontSize: '24px',
        color:'#fff',
        cssClass: 'apexcharts-yaxis-title',
      },
    },
    subtitle: {
      text: `${uniqueUniqueInsightCount}`,
      offsetX: 30,
      style: {
        fontSize: '14px',
        color:'#fff',
        cssClass: 'apexcharts-yaxis-title',
      },
    },
  };

  return (
    <div>
      <Chart options={spark2} series={spark2.series} type="area" width={"100%"} height={97} />
    </div>
  );
};

export default SparklineChart4;
